import '@shared/types-v0.1.0'
import { type GenericSchema, array, lazy, optional, strictObject, string } from 'shared/src/libs/valibot'
import type { Props } from './definition'

type Page = {
	page: string
	path: string
	params?: string[]
	subPages?: Page[]
}

export type NavigationScheme = Page[]

const NavigationScheme: GenericSchema<Page[]> = array(
	strictObject({
		page: string('"page" must be string.'),
		path: string('"page" must be string.'),
		params: optional(array(string())),
		subPages: optional(lazy(() => NavigationScheme)),
	})
)

export const validateNavigationScheme = (p: Props) => {
	const result = R.libs.valibot.safeParse(NavigationScheme, p.navigationScheme)

	if (!result.success) {
		// Через forof, т.к. map добовляет запятые.
		// <pre> делает красоту c JSON.stringify.
		let html = '<pre><p>Scheme errors:</p>'
		for (const issue of result.issues) {
			html += `<hr width="100%" size="0.5px">${
				issue.type === 'strict_object' && issue.received !== 'undefined'
					? `There is no key "${R.libs.just.last(issue.path || []).key}" at Scheme specification.`
					: issue.message
			}<br>${issue.path?.[0].value ? JSON.stringify(issue.path?.[0].value, null, '  ') : JSON.stringify(issue.input, null, '  ')}`
		}
		html += '<hr width="100%" size="0.5px"></pre>'

		return html
	}
	return true
}
